define("shared/errors/fetch", ["exports", "shared/utils/errors/define-error"], function (_exports, _defineError) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ServerError = _exports.RequestError = _exports.RateLimitError = _exports.NetworkError = _exports.FetchError = void 0;
  0; //eaimeta@70e063a35619d71f0,"shared/utils/errors/define-error"eaimeta@70e063a35619d71f
  const FetchError = _exports.FetchError = (0, _defineError.defineError)({
    name: 'FetchError',
    message: 'FetchError',
    resolve: function handleFetchError() {
      let title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Request Error';
      let message = arguments.length > 1 ? arguments[1] : undefined;
      if (this.alerts && message) {
        this.alerts.alert(message, {
          title
        });
      }
    }
  });
  const NetworkError = _exports.NetworkError = (0, _defineError.defineError)({
    name: 'NetworkError',
    message: 'A network error occured. Please try again.',
    extends: FetchError
  });
  const RateLimitError = _exports.RateLimitError = (0, _defineError.defineError)({
    name: 'RateLimitError',
    message: 'You have sent too many requests recently. Please wait before trying again.',
    extends: FetchError
  });
  const RequestError = _exports.RequestError = (0, _defineError.defineError)({
    name: 'RequestError',
    message: 'Your request was invalid. Please try again.',
    extends: FetchError
  });
  const ServerError = _exports.ServerError = (0, _defineError.defineError)({
    name: 'ServerError',
    message: 'A server error occured. Please try again.',
    extends: FetchError
  });
});